import { Container, Typography } from "@mui/material";
import type { JSX } from "react";

export default function UnauthorizedPage(): JSX.Element {
  return (
    <Container sx={{ mt: 2 }}>
      <Typography variant="h4" component="h1" align="center">
        You are unauthorized to access this page.
      </Typography>
    </Container>
  );
}
